import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import QRCode from "qrcode";
import Drawer from "@mui/material/Drawer";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { alertMessage } from "../../actions/auth";
import { Bar } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { Chart } from "chart.js/auto";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Fab } from "@mui/material";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import PublishIcon from "@mui/icons-material/Publish";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { FormControlLabel } from "@mui/material";

import { API_URL } from "../../actions/auth";

import { themeStyle } from "../../components/Components";
import UploadIcon from "@mui/icons-material/Upload";

import { styled } from "@mui/material";
import { CloudUpload, Description, Close } from "@mui/icons-material";

const Dropzone = styled("div")(({ theme }) => ({
  border: `2px dashed ` + themeStyle.primaryColor,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(6),
  textAlign: "center",
  cursor: "pointer",
}));

const FileUploadCard = () => {
  return (
    <Box sx={{ maxWidth: 400, mx: "auto", marginBottom: "50px" }} elevation={1}>
      <Dropzone>
        <CloudUpload
          fontSize="large"
          sx={{ color: themeStyle.primaryColor, mb: 1, fontSize: "50px" }}
        />
        <Typography variant="body1">Click here to upload your file</Typography>
        <Typography variant="caption" color="text.secondary">
          with .xlsx file extension (Max 25MB)
        </Typography>
      </Dropzone>
    </Box>
  );
};
function Teachers() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [random, setRandom] = useState(0);
  const [search, setSearch] = useState("");
  const [profile, setProfile] = useState({});
  const [classIdList, setClassIdList] = useState({});
  const [teacherList, setTeacherList] = useState([]);
  const [ogTeachers, setOGTeachers] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedPage, setSelectedPage] = useState("TEACHERS");
  const [isUploading, setIsUploading] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);

  function submitTeacherData() {
    setIsLoading(true);
    setOpen3(false);
    setOpen2(false);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };
    body["teacher"] = profile;

    body = JSON.stringify(body);
    axios
      .post(API_URL + "/save_teacher_data_manual", body, config)
      .then((res) => {
        getData();
      });
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {" "}
            <h2>File Details:</h2>
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File too big.",
                    "File size should be less than 25 MB."
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : selectedFile.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File name to obig.",
                    "File size should be less than 50 characters."
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function handleSearch(text) {
    setSearch(text);
    if (text.length == 0) {
      setTeacherList(ogTeachers);
      setSearch("");
      setRandom(makeid(5));
    } else {
      var tempUsers = [];

      for (var i = 0; i < ogTeachers.length; i++) {
        if (
          ogTeachers[i]["full_name"]
            .toLowerCase()
            .includes(text.toLowerCase()) ||
          ogTeachers[i]["email"].toLowerCase().includes(text.toLowerCase())
        ) {
          tempUsers.push(ogTeachers[i]);
        }
      }
      setCurrentPage(1);
      setTeacherList(tempUsers);
      setRandom(makeid(5));
    }
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function handleCurrentPage(val) {
    var tempUsers = Array.from(ogTeachers);
    setSearch("");
    setCurrentPage(val);
    setTeacherList(tempUsers.splice((val - 1) * 25, 25));
  }

  function getData() {
    var body = {
      uid: state.auth.user.uid,
      institution_id: state.auth.user.institution_id,
    };
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };
    axios.post(API_URL + "/get_teachers_list", body, config).then((res) => {
      if (res.data.length != 0) {
        if (profile == null || JSON.stringify(profile) == "{}") {
          setProfile(res.data[0]);
        } else {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i]["user_id"] == profile["user_id"]) {
              setProfile(res.data[i]);
              break;
            }
          }
        }
        setClassIdList(JSON.parse(res.data[0]["class_id_list"]));
        setOGTeachers(res.data);
        setProfile(res.data[0]);
        setTeacherList(Array.from(res.data).splice(0, 25));
      }
      setIsLoading(false);
    });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  function onFileUpload() {
    setIsUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    formData.append("user_id", state.auth.user.user_id);
    formData.append("filename", selectedFile.name);
    formData.append("institution_id", state.auth.user.institution_id);

    axios
      .post(API_URL + "/update_teacher_xl", formData, config)
      .then(() => {
        setIsUploading(false);

        createAlert("SUCCESS", "Success.", "Document uploaded.");
        getData();
      })
      .catch((err) => {
        setIsUploading(false);

        console.log("___");
        console.log(err);
        createAlert("ERROR", "Error", err.response.data);
      });

    handleClose();
    document.getElementById("contained-button-file").value = "";
  }

  function onFileChange(event) {
    // Update the state
    setSelectedFile(event.target.files[0]);

    handleOpen();
  }

  function onFileClick(event) {
    // Update the state
    document.getElementById("contained-button-file").value = "";
  }

  function getContent() {
    console.log(ogTeachers.length);
    if (selectedPage == "TEACHERS") {
      return (
        <Grid container>
          <Grid item md={12}>
            {ogTeachers.length == 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "40px",
                }}
              >
                <SearchOffIcon
                  style={{
                    fontSize: "200px",
                    marginBottom: "20px",
                    color: themeStyle.primaryColor,
                  }}
                />
                <Typography
                  variant="h6"
                  style={{ color: themeStyle.primaryColor }}
                >
                  No teachers found in the records
                </Typography>
              </div>
            ) : (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    padding: "25px",
                  }}
                >
                  <Grid container spacing={3} justifyContent={"flex-end"}>
                    <Grid item md={4}>
                      <div
                        style={{
                          backgroundColor: themeStyle.primaryCardColor,
                          borderRadius: "15px",
                          padding: "15px",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            color: themeStyle.primaryColor,
                            fontSize: "25px",
                            fontWeight: "bold",
                          }}
                        >
                          {profile.full_name}
                        </div>
                        <br />
                        <span
                          style={{
                            fontSize: "20px",
                            color: themeStyle.secondaryColor,
                            fontWeight: "bold",
                          }}
                        >
                          Personal Information
                        </span>
                        <hr />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span>CHSID:</span>
                          <span style={{ color: themeStyle.primaryColor }}>
                            {profile.user_id ? (
                              profile.user_id
                            ) : (
                              <span style={{ color: "#ff3333" }}>
                                NOT AVAILABLE
                              </span>
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span>Gender:</span>
                          <span style={{ color: themeStyle.primaryColor }}>
                            {profile.gender ? (
                              profile.gender
                            ) : (
                              <span style={{ color: "#ff3333" }}>
                                NOT AVAILABLE
                              </span>
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span>Birthdate:</span>
                          <span style={{ color: themeStyle.primaryColor }}>
                            {profile.birthdate ? (
                              profile.birthdate
                            ) : (
                              <span style={{ color: "#ff3333" }}>
                                NOT AVAILABLE
                              </span>
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span>Email:</span>
                          <span style={{ color: themeStyle.primaryColor }}>
                            {profile.email ? (
                              profile.email
                            ) : (
                              <span style={{ color: "#ff3333" }}>
                                NOT AVAILABLE
                              </span>
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <span>Phone Number:</span>
                          <span style={{ color: themeStyle.primaryColor }}>
                            {profile.phone_number ? (
                              profile.phone_number
                            ) : (
                              <span style={{ color: "#ff3333" }}>
                                NOT AVAILABLE
                              </span>
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "16px",
                          }}
                        >
                          <span>Alternate Phone:</span>
                          <span style={{ color: themeStyle.primaryColor }}>
                            {profile.alternate_phone_number ? (
                              profile.alternate_phone_number
                            ) : (
                              <span style={{ color: "#ff3333" }}>
                                NOT AVAILABLE
                              </span>
                            )}
                          </span>
                        </div>
                        <br />
                        <span
                          style={{
                            fontSize: "20px",
                            color: themeStyle.secondaryColor,
                            fontWeight: "bold",
                          }}
                        >
                          Class Information
                        </span>

                        <hr />
                        {Object.keys(classIdList).length == 0 ? (
                          <div>No classes appointed.</div>
                        ) : (
                          <div>
                            {" "}
                            {Object.keys(classIdList).map((semester) => (
                              <Fragment>
                                <h3>{semester}</h3>
                                {Object.keys(classIdList[semester]).map(
                                  (classs) => (
                                    <Fragment>
                                      {Object.keys(
                                        classIdList[semester][classs]
                                      ).map((division) => (
                                        <Fragment>
                                          <b> {classs + " " + division}</b>
                                          <br></br>
                                          {classIdList[semester][classs][
                                            division
                                          ].map((subject) => (
                                            <span>
                                              {Object.keys(subject)[0]}
                                              <br></br>
                                            </span>
                                          ))}
                                          <br></br>
                                        </Fragment>
                                      ))}
                                    </Fragment>
                                  )
                                )}
                              </Fragment>
                            ))}{" "}
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item md={8}>
                      <div
                        style={{
                          border: "3px solid " + themeStyle.primaryCardColor,
                          borderRadius: "15px",
                          padding: "15px",
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          style={{
                            justifyContent: "flex-start",
                            textAlign: "left",
                            paddingBottom: "15px",
                            color: themeStyle.primaryColor,
                            borderBottom: "1px solid" + themeStyle.primaryColor,
                            backgroundColor: themeStyle.primaryCardColor,
                            width: "103.2%",
                            borderTopRightRadius: "15px",
                            borderTopLeftRadius: "15px",
                          }}
                        >
                          <Grid item md={1}>
                            Pic
                          </Grid>
                          <Grid item md={4}>
                            Full Name
                          </Grid>
                          <Grid item md={4}>
                            Email
                          </Grid>
                          <Grid item md={2}>
                            Phone Number
                          </Grid>
                          <Grid item md={1}>
                            Edit
                          </Grid>
                        </Grid>
                        {teacherList.map((user, index) => (
                          <Grid
                            onClick={() => {
                              setProfile(user);
                              setClassIdList(JSON.parse(user["class_id_list"]));
                            }}
                            container
                            style={{
                              backgroundColor:
                                user["user_id"] == profile["user_id"]
                                  ? themeStyle.primaryColorLight
                                  : "white",
                              color: "black",
                              padding: "15px",
                              alignItems: "center",
                              paddingTop: "23px",
                              borderRadius: "25px",
                            }}
                          >
                            <Grid item md={1}>
                              <Avatar
                                sx={{ marginTop: "-7px" }}
                                alt={user["full_name"]}
                                src={API_URL + "/media/" + user["image"]}
                              />
                            </Grid>
                            <Grid
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setProfile(user);
                                setClassIdList(
                                  JSON.parse(user["class_id_list"])
                                );
                              }}
                              item
                              md={4}
                            >
                              {user["full_name"]}
                            </Grid>
                            <Grid item md={4}>
                              {user["email"]}
                            </Grid>

                            <Grid item md={2} style={{ textAlign: "center" }}>
                              {user["phone_number"]}
                            </Grid>
                            <Grid item md={1} style={{ textAlign: "center" }}>
                              <EditIcon
                                onClick={() => {
                                  setProfile(user);
                                  setOpen2(true);
                                }}
                                style={{
                                  color: themeStyle.primaryColor,
                                  cursor: "pointer",
                                }}
                              />
                            </Grid>
                          </Grid>
                        ))}
                      </div>
                      {teacherList.length > 15 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "-15px",
                            marginTop: "-15px",
                          }}
                        >
                          {Array.from(
                            Array(Math.ceil(ogTeachers.length / 25)).keys()
                          ).map((temp, index) => (
                            <div
                              style={{
                                cursor: "pointer",
                                margin: "3px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "25px",
                                height: "25px",
                                borderRadius: "30px",
                                color: "white",
                                backgroundColor: themeStyle.primaryColor,
                              }}
                              onClick={() => {
                                handleCurrentPage(index + 1);
                              }}
                            >
                              {index + 1}
                            </div>
                          ))}
                        </div>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      );
    } else {
      return (
        <div
          style={{
            width: "100%",
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "30%",
            }}
          >
            <label
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              htmlFor="contained-button-file"
            >
              <input
                style={{ display: "none" }}
                id="contained-button-file"
                type="file"
                onChange={(e) => onFileChange(e)}
              />
              <img
                style={{ maxHeight: "256px", margin: "100px 0px 25px 0px" }}
                src={require("../../img/xl.png")}
              />
              <Button
                style={{
                  width: "100%",
                  fontSize: "25px",
                  height: "50px",
                  marginTop: "-1px",
                  backgroundColor: themeStyle.primaryColor,
                  fontFamily: "Campton Book",
                }}
                variant="contained"
                component="span"
              >
                Upload Latest Teacher Data
              </Button>
              <br />
              <br />
            </label>
            <br />
            <br />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              {isUploading ? <CircularProgress /> : ""}
            </div>
          </div>
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_onboarding) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  backgroundColor: themeStyle.backgroundColor,
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5} justifyContent="flex-end">
                    <Grid item md={2}>
                      {ogTeachers.length + " Teachers"}
                    </Grid>
                    <Grid item md={9}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Search User / Email"
                        variant="outlined"
                        value={search}
                        size="small"
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                }
              />
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open3}
                onClose={() => setOpen3(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open3}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                      borderRadius: "15px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen3(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>
                      <h3>Submit Teacher Data?</h3>
                      <span>
                        This action cannot be reversed. It will be saved until
                        edited.
                      </span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => submitTeacherData()}
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          Yes
                        </Button>
                        <Button
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => setOpen3(false)}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <Modal
                open={open2}
                onClose={() => setOpen2(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open2}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "60vw",
                      height: "40vh",
                      padding: "20px",
                      borderRadius: "25px",
                    }}
                  >
                    {isUploading ? (
                      <CircularProgress />
                    ) : (
                      <Fragment>
                        <div
                          style={{
                            fontSize: "25px",
                            color: themeStyle.primaryColor,
                          }}
                        >
                          Personal Information
                        </div>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6} lg={5}>
                            <TextField
                              fullWidth
                              label="Full Name"
                              value={profile.full_name || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  full_name: e.target.value,
                                })
                              }
                              margin="normal"
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={5}>
                            <TextField
                              fullWidth
                              label="Email"
                              value={profile.email || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  email: e.target.value,
                                })
                              }
                              margin="normal"
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={2}>
                            <Select
                              fullWidth
                              value={profile.gender || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  gender: e.target.value,
                                })
                              }
                              style={{ marginTop: "15px" }}
                              margin="normal"
                            >
                              <MenuItem value="Male">Male</MenuItem>
                              <MenuItem value="Female">Female</MenuItem>
                              <MenuItem value="Other">Other</MenuItem>
                            </Select>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <TextField
                              fullWidth
                              label="Phone Number"
                              type="number"
                              value={profile.phone_number || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  phone_number: e.target.value,
                                })
                              }
                              margin="normal"
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <TextField
                              fullWidth
                              type="date"
                              label="Birthdate"
                              value={
                                moment(
                                  profile.birthdate,
                                  "DD-MM-YYYY"
                                ).toDate() ?? ""
                              }
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  birthdate: e.target.value,
                                })
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              margin="normal"
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <TextField
                              fullWidth
                              label="Alternate Phone"
                              type="number"
                              value={profile.alternate_phone_number || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  alternate_phone_number: e.target.value,
                                })
                              }
                              margin="normal"
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <TextField
                              fullWidth
                              label="User ID"
                              value={profile.user_id || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  user_id: e.target.value,
                                })
                              }
                              margin="normal"
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={6}>
                            <TextField
                              fullWidth
                              label="Type of Impairments"
                              value={profile.type_of_impairments || ""}
                              onChange={(e) =>
                                setProfile({
                                  ...profile,
                                  type_of_impairments: e.target.value,
                                })
                              }
                              margin="normal"
                            />
                          </Grid>
                        </Grid>
                        <div
                          style={{
                            height: "50px",
                            width: "250px",
                            padding: "5px 10px",
                            borderRadius: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "none",
                            backgroundColor: themeStyle.primaryColor,
                            position: "absolute",
                            bottom: 30,
                            right: 30,
                            cursor: "pointer",
                          }}
                          onClick={() => setOpen3(true)}
                          aria-label="add"
                        >
                          <SaveIcon
                            style={{
                              color: "white",
                              marginRight: "10px",
                              fontSize: "30px",
                            }}
                          />
                          <div
                            style={{
                              color: "white",
                              fontSize: "18px",
                              fontWeight: "bold",
                            }}
                          >
                            Save Teacher Data
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </div>
                </Fade>
              </Modal>
              <Modal
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                      borderRadius: "25px",
                    }}
                  >
                    {fileData()}
                  </div>
                </Fade>
              </Modal>
              <Drawer
                anchor={"right"}
                open={toggleDrawer}
                onClose={() => setToggleDrawer(false)}
              >
                <div
                  style={{
                    width: "25vw",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    marginTop: "-60px",
                  }}
                >
                  <img
                    style={{
                      maxHeight: "128px",
                      margin: "100px 0px 25px 0px",
                    }}
                    src={require("../../img/xl.png")}
                  />
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      fontFamily: "Campton Book",
                      color: themeStyle.primaryColor,
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    Upload Spreadsheet
                  </Typography>
                  <label
                    style={{
                      borderRadius: "15px",
                      padding: "20px",
                      backgroundColor: "white",
                    }}
                    htmlFor="contained-button-file"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file"
                      type="file"
                      onChange={(e) => onFileChange(e)}
                    />

                    <FileUploadCard />
                    <Button
                      style={{
                        width: "100%",
                        fontSize: "20px",
                        height: "40px",
                        marginTop: "-1px",
                        backgroundColor: themeStyle.primaryColor,
                        fontFamily: "Campton Book",
                      }}
                      variant="contained"
                      component="span"
                    >
                      Upload Latest XL File
                    </Button>
                    <br />
                    <br />
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      {isUploading ? <CircularProgress /> : ""}
                    </div>
                  </label>
                </div>
              </Drawer>
              <div
                style={{
                  height: "50px",
                  width: "175px",
                  padding: "5px 10px",
                  borderRadius: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "none",
                  backgroundColor: themeStyle.primaryColor,
                  position: "fixed",
                  bottom: 30,
                  right: 30,
                  cursor: "pointer",
                }}
                onClick={() => setToggleDrawer(true)}
                aria-label="add"
              >
                <PublishIcon
                  style={{
                    color: "white",
                    marginRight: "5px",
                    fontSize: "30px",
                  }}
                />
                <div
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Upload XL
                </div>
              </div>
              <div
                style={{
                  borderRadius: "15px",
                  margin: "45px 0px 20px 70px",
                  backgroundColor: "white",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: themeStyle.backgroundColor,
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Teachers;
